export default __webpack_public_path__ + "static/media/ClinicalLogo.5a4dd796.png";